<template>
  <div class="chooseschool chooseschool2">
    <div class="main">
      <div class="search-box" style="background: #f2f2f2;">
        <span class="search-input">
          <input placeholder="请输入学校名称" v-model="message">
          <span class="clearbtn" v-if="message!=''" @click="clearInput"></span>
        </span>
        <span class="btn" @click="searchSchool()">搜索</span>
      </div>
      <div class="search-result search-result2" v-if="!iSearch && nearSchoolList.length>0">
        <div class="c-gray">附近学校</div>
        <ul class="list">
          <li v-for="(item,index) in nearSchoolList" :key='index' v-html='item.schoolName'@click="saveInfo(item)">
            <a>{{item.schoolName}}</a>
          </li>
        </ul>
      </div>
      <div class="search-result search-result2" v-if="iSearch && schoolList.length>0">
        <div class="c-gray">搜索结果</div>
        <ul class="list">
          <li v-for="(item,index) in schoolList" :key='index' v-html='item.schoolName'@click="saveInfo(item)">
            <a>{{item.schoolName}}</a>
          </li>
        </ul>
      </div>
      <div v-if="isjdlw" class="jdlw-ready">
        <img src="../assets/images/empty-00.png" />
        <p>亲爱的同学，你的学校当前尚未开通，快搜索别的学校看看吧~</p>
      </div>
    </div>
    <div class="bottomTips" v-if="showBottomTips">
      <p>上海鎏帑网络科技有限公司   沪ICP备18024716号-1</p>
      <div >
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../assets/images/record-icon.png" style="width:0.2rem;height:0.2rem;margin-top:0.08rem;float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010402004817号</p>
        </a>
      </div>
      <p> 联系电话：021-60761299</p>
    </div>
  </div>
</template>

<script>
  // var wx = require('weixin-js-sdk');
  import {actions} from '../store/actions'
  import { callNative } from "../assets/js/bridge";
  // import { MessageBox } from 'mint-ui'

  export default {
    data () {
      return {
        schoolList: [],
        nearSchoolList: [],
        iSearch: false, // 标识搜索状态
        message: '',
        showBottomTips: false,
        notFound: false,
        isjdlw: false
      }
    },
    mounted () {
      // 梨涡
      if (this.$utils.getCookie('source') && this.$utils.getCookie('source') == 'jdlw') {
        if (localStorage.getItem('schoolInfo')) {

        } else {
          // 监听返回按钮
          if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL)
            window.addEventListener('popstate', this.backJdlw, false) // false阻止默认事件
          }
          // 搜索文案弹窗
          this.isjdlw = true;
        }
      }
    },
    destroyed () {
      window.removeEventListener('popstate', this.backJdlw, false);//false阻止默认事件
    },
    created () {
      var _this = this;
      var u = encodeURIComponent(window.location.href.split('#')[0]);
      actions.getJslbsConf(_this,u,function (data) {
        let newData = JSON.parse(data);
        wx.config({
          debug: false,
          appId: newData.appId,
          timestamp: newData.timestamp,
          nonceStr: newData.nonceStr,
          signature: newData.signature,
          jsApiList: newData.jsApiList
        })
        wx.ready(function () {
          _this.$indicator.open({
            text: '正在努力定位中'
          });
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              var params = {
                keyword: '',
                lat: res.latitude,
                lon: res.longitude
              }
              actions.postSchoolSearch(_this, params, function (data) {
                _this.$indicator.close();
                if (data.length > 0) {
                  _this.nearSchoolList = data;
                  for(let item of _this.nearSchoolList){
                    item.schoolName = item.school_name
                  }
                }else{
                  _this.$messagebox.alert('未查询到附近学校，请手动搜索','')
                }
              })
            },
            fail: function (res) {
              _this.$indicator.close();
              // _this.$messagebox.alert('获取错误信息：'+JSON.stringify(res),'')
              _this.$messagebox.alert('定位失败，请查看是否允许定位或者手动进行搜索')
            }
          })
        })
        wx.error(function (res) {
          // alert(JSON.stringify(res));
          // window.location.reload();
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      },function (data){
        _this.$indicator.close();
        _this.$messagebox.alert('未查询到附近学校，请手动搜索','')
      })
      if (document.domain.indexOf('xiyoushi.com') >= 0) {
        _this.showBottomTips = true
      }
    },
    watch: {
      message () {
        this.searchSchool()
      }
    },
    methods: {
      backJdlw () {
        callNative("jsCallNativePage", {"routeUrl" : "yocial://life_consume/"})
      },
      key(e){
        var _this=this;
        if(e.keyCode=='13'){
          _this.searchSchool(_this.message);
        }
      },
      saveInfo: function (e) {
        var _this = this;
        if(_this.$store.state.wxUid){
          actions.toggleSchool(_this, {school_id: e.school_id,uid: _this.$store.state.wxUid}, (data) => {
          },function(){})
          if(_this.$utils.getCookie('clc') && _this.$utils.getCookie('clc').length > 0){
            let key = _this.$utils.getCookie('clc');
            _this.$utils.setCookie('clc','');
            _this.acceptInvite(key,e.school_id);
          }  
        }
        var schoolInfo = {}
        schoolInfo.schoolId = e.school_id
        schoolInfo.schoolName = e.school_name
        this.$store.commit('changeSchoolInfo', schoolInfo)
        this.$router.push({path: 'index'});
      },
      searchSchool () {
        if (!this.message || this.message.length < 2) {
          this.iSearch = false
          this.schoolList = []
          return
        } else {
          this.iSearch = true
        }
        var _this = this
        var params = {keyword: this.message}
        actions.postSearchSchool(_this, params, (data) => {
          if (data.length > 0) {
            this.schoolList = []
            for (let item of data) {
              item.school_name = item.school_name
              let replaceReg = new RegExp(_this.message, 'g');
              let replaceString = '<span class="search-text">' + _this.message + '</span>';
              item.schoolName = item.school_name.replace(replaceReg, replaceString);
            }
            this.schoolList = data
          } else {
            this.schoolList = []
//            _this.$messagebox.alert('未查询到相关学校','')
          }
        })
      },
      clearInput () {
        this.message = ''
      },
      // 邀请有礼 接受邀请
      acceptInvite(key,school_id) {
        let _this = this;
        actions.clcAcceptInvite(_this, {school_id: school_id,link: key}, (data) => {
            
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// ChooseSchool.vue?66736663